import React from "react";
import { Mail } from "lucide-react";

const FacultyCard = ({ faculty, isHod = false }) => {
  const backendURL = process.env.REACT_APP_BACKEND_URL?.replace(/\/$/, ""); // remove trailing slash
  const profilePath = faculty.profile_image?.replace(/^\/+/, ""); // remove leading slash
  const imagePath = faculty.profile_image
    ? `${backendURL}/${profilePath}`
    : null;

  const qualifications =
    faculty.faculty_qualifications?.length > 0
      ? faculty.faculty_qualifications.join(", ")
      : null;

  return (
    <div
      className={`w-full flex items-center bg-white rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-all duration-200 relative`}
    >
      {/* Image Section */}
      <div className="flex-shrink-0 flex items-center justify-center p-3">
        <div
          className={`w-24 h-24 rounded-lg overflow-hidden flex items-center justify-center border border-gray-200`}
        >
          {faculty.profile_image ? (
            <img
              src={imagePath}
              alt={faculty.faculty_name}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          ) : (
            <div
              className={`w-full h-full flex items-center justify-center ${isHod ? "bg-[#600000]" : "bg-[#800000]"} text-white text-2xl font-semibold`}
            >
              {faculty.faculty_name?.charAt(0)}
            </div>
          )}
        </div>
      </div>

      {/* Info Section */}
      <div className="flex flex-col sm:flex-row justify-between flex-grow p-4 gap-4">
        {/* Left: Details */}
        <div className="space-y-1">
          <h3 className="text-lg font-semibold text-gray-900 leading-tight">
            {faculty.faculty_name}
          </h3>

          {faculty.faculty_designation && (
            <p
              className={`text-sm ${isHod ? "text-[#600000]" : "text-[#800000]"} font-medium`}
            >
              {faculty.faculty_designation}
            </p>
          )}

          {qualifications && (
            <p className="text-sm text-gray-700">
              <span className="font-medium text-gray-800">Qualifications:</span>{" "}
              {qualifications}
            </p>
          )}

          {faculty.faculty_specializations?.length > 0 && (
            <p className="text-sm text-gray-700">
              <span className="font-medium text-gray-800">
                Specializations:
              </span>{" "}
              {faculty.faculty_specializations.join(", ")}
            </p>
          )}
        </div>

        {/* Right: Contact */}
        <div className="flex flex-col items-start sm:items-end justify-center gap-2">
          {faculty.email && (
            <>
              <a
                href={`https://mail.google.com/mail/?view=cm&fs=1&to=${faculty.email}&su=Inquiry%20about%20${encodeURIComponent(faculty.faculty_name)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-sm text-[#800000] hover:text-[#660000] transition-colors"
              >
                <Mail className="w-4 h-4" />
                Email
              </a>

              <p className="text-xs text-gray-400 break-all">{faculty.email}</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FacultyCard;
